"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._connectToContracts = exports._uniTokenIsMock = exports._priceFeedIsTestnet = exports._getTestERC20TokenNoLimit = exports._getTestERC20Token = exports._getLPToken = exports._getERC20Token = exports._getPreonVaultToken = exports._LiquityContract = void 0;
const contracts_1 = require("@ethersproject/contracts");
const ActivePool_json_1 = __importDefault(require("../abi/ActivePool.json"));
const BorrowerOperations_json_1 = __importDefault(require("../abi/BorrowerOperations.json"));
const TroveManager_json_1 = __importDefault(require("../abi/TroveManager.json"));
const STARToken_json_1 = __importDefault(require("../abi/STARToken.json"));
const CollSurplusPool_json_1 = __importDefault(require("../abi/CollSurplusPool.json"));
const CommunityIssuance_json_1 = __importDefault(require("../abi/CommunityIssuance.json"));
const DefaultPool_json_1 = __importDefault(require("../abi/DefaultPool.json"));
const PREONToken_json_1 = __importDefault(require("../abi/PREONToken.json"));
const HintHelpers_json_1 = __importDefault(require("../abi/HintHelpers.json"));
const MultiTroveGetter_json_1 = __importDefault(require("../abi/MultiTroveGetter.json"));
const PriceFeed_json_1 = __importDefault(require("../abi/PriceFeed.json"));
const PriceFeedTestnet_json_1 = __importDefault(require("../abi/PriceFeedTestnet.json"));
const SortedTroves_json_1 = __importDefault(require("../abi/SortedTroves.json"));
const StabilityPool_json_1 = __importDefault(require("../abi/StabilityPool.json"));
const GasPool_json_1 = __importDefault(require("../abi/GasPool.json"));
const IERC20_json_1 = __importDefault(require("../abi/IERC20.json"));
const PreonController_json_1 = __importDefault(require("../abi/PreonController.json"));
const Farm_json_1 = __importDefault(require("../abi/Farm.json"));
const vePREONEmissions_json_1 = __importDefault(require("../abi/vePREONEmissions.json"));
const vePREON_json_1 = __importDefault(require("../abi/vePREON.json"));
const BoostedFarm_json_1 = __importDefault(require("../abi/BoostedFarm.json"));
// Implementations
const buildEstimatedFunctions = (estimateFunctions, functions) => Object.fromEntries(Object.keys(estimateFunctions).map(functionName => [
    functionName,
    async (overrides, adjustEstimate, ...args) => {
        if (overrides.gasLimit === undefined) {
            const estimatedGas = await estimateFunctions[functionName](...args, overrides);
            overrides = {
                ...overrides,
                gasLimit: adjustEstimate(estimatedGas)
            };
        }
        return functions[functionName](...args, overrides);
    }
]));
class _LiquityContract extends contracts_1.Contract {
    constructor(addressOrName, contractInterface, signerOrProvider) {
        super(addressOrName, contractInterface, signerOrProvider);
        // this.estimateAndCall = buildEstimatedFunctions(this.estimateGas, this);
        this.estimateAndPopulate = buildEstimatedFunctions(this.estimateGas, this.populateTransaction);
    }
    extractEvents(logs, name) {
        return logs
            .filter(log => log.address === this.address)
            .map(log => this.interface.parseLog(log))
            .filter(e => e.name === name);
    }
}
exports._LiquityContract = _LiquityContract;
const _getPreonVaultToken = (address, signerOrProvider) => {
    return {
        vault: new _LiquityContract(address, IERC20_json_1.default, signerOrProvider)
    };
};
exports._getPreonVaultToken = _getPreonVaultToken;
const _getERC20Token = (address, signerOrProvider) => {
    return {
        token: new _LiquityContract(address, IERC20_json_1.default, signerOrProvider)
    };
};
exports._getERC20Token = _getERC20Token;
const _getLPToken = (address, signerOrProvider) => {
    return {
        // ! TODO: #pending: replace lp token #address
        token: new _LiquityContract("0xCF80070DBe669eE4e496246819dB45076eD4A427", IERC20_json_1.default, signerOrProvider)
    };
};
exports._getLPToken = _getLPToken;
const _getTestERC20Token = (address, signerOrProvider) => {
    return {
        token: new _LiquityContract(address, IERC20_json_1.default, signerOrProvider)
    };
};
exports._getTestERC20Token = _getTestERC20Token;
const _getTestERC20TokenNoLimit = (address, signerOrProvider) => {
    return {
        token: new _LiquityContract(address, IERC20_json_1.default, signerOrProvider)
    };
};
exports._getTestERC20TokenNoLimit = _getTestERC20TokenNoLimit;
/** @internal */
const _priceFeedIsTestnet = (priceFeed) => "setPrice" in priceFeed;
exports._priceFeedIsTestnet = _priceFeedIsTestnet;
/** @internal */
const _uniTokenIsMock = (uniToken) => "mint" in uniToken;
exports._uniTokenIsMock = _uniTokenIsMock;
const getAbi = (priceFeedIsTestnet) => ({
    activePool: ActivePool_json_1.default,
    borrowerOperations: BorrowerOperations_json_1.default,
    troveManager: TroveManager_json_1.default,
    starToken: STARToken_json_1.default,
    communityIssuance: CommunityIssuance_json_1.default,
    defaultPool: DefaultPool_json_1.default,
    preonToken: PREONToken_json_1.default,
    hintHelpers: HintHelpers_json_1.default,
    multiTroveGetter: MultiTroveGetter_json_1.default,
    priceFeed: priceFeedIsTestnet ? PriceFeedTestnet_json_1.default : PriceFeed_json_1.default,
    sortedTroves: SortedTroves_json_1.default,
    stabilityPool: StabilityPool_json_1.default,
    gasPool: GasPool_json_1.default,
    collSurplusPool: CollSurplusPool_json_1.default,
    preonController: PreonController_json_1.default,
    farm: Farm_json_1.default,
    boostedFarm: BoostedFarm_json_1.default,
    vePREON: vePREON_json_1.default,
    vePREONEmissions: vePREONEmissions_json_1.default,
    lpToken: IERC20_json_1.default,
    STARPriceFeed: priceFeedIsTestnet ? PriceFeedTestnet_json_1.default : PriceFeed_json_1.default
});
const mapLiquityContracts = (contracts, f) => Object.fromEntries(Object.entries(contracts).map(([key, t]) => [key, f(t, key)]));
/** @internal */
const _connectToContracts = (signerOrProvider, { addresses, _priceFeedIsTestnet }) => {
    const abi = getAbi(_priceFeedIsTestnet);
    return mapLiquityContracts(addresses, (address, key) => new _LiquityContract(address, abi[key], signerOrProvider));
};
exports._connectToContracts = _connectToContracts;
//# sourceMappingURL=contracts.js.map